import config from "../Config";

let baseURL = config.api.baseUrl;

export const forgotPassword = (email) => {
  return fetch(`${baseURL}/users/password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user: { email } }),
  }).then((res) => res.json());
};

export const resetPassword = (credentials) => {
  return fetch(`${baseURL}/users/password`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user: credentials }),
  });
};
